var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClinicalReview20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25657_14689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.25C14.4404 16.25 15 15.6904 15 15C15 14.3096 14.4404 13.75 13.75 13.75C13.0596 13.75 12.5 14.3096 12.5 15C12.5 15.6904 13.0596 16.25 13.75 16.25Z",
    fill: "#E9EEF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6106 14.6741C18.2243 13.6903 17.5579 12.8415 16.6939 12.2329C15.83 11.6242 14.8064 11.2825 13.75 11.25C12.6936 11.2825 11.67 11.6242 10.8061 12.2329C9.94206 12.8415 9.27566 13.6903 8.88944 14.6741L8.75 15L8.88944 15.3259C9.27566 16.3097 9.94206 17.1585 10.8061 17.7671C11.67 18.3758 12.6936 18.7175 13.75 18.75C14.8064 18.7175 15.83 18.3758 16.6939 17.7671C17.5579 17.1585 18.2243 16.3097 18.6106 15.3259L18.75 15L18.6106 14.6741ZM13.75 17.5C13.2555 17.5 12.7722 17.3534 12.3611 17.0787C11.95 16.804 11.6295 16.4135 11.4403 15.9567C11.2511 15.4999 11.2016 14.9972 11.298 14.5123C11.3945 14.0273 11.6326 13.5819 11.9822 13.2322C12.3319 12.8826 12.7773 12.6445 13.2623 12.548C13.7472 12.4516 14.2499 12.5011 14.7067 12.6903C15.1635 12.8795 15.554 13.2 15.8287 13.6111C16.1034 14.0222 16.25 14.5055 16.25 15C16.2493 15.6628 15.9856 16.2983 15.5169 16.7669C15.0483 17.2356 14.4128 17.4993 13.75 17.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.5H4.375V4.375H6.25V6.25H13.75V4.375H15.625V10H16.875V4.375C16.875 4.04348 16.7433 3.72554 16.5089 3.49112C16.2745 3.2567 15.9565 3.125 15.625 3.125H13.75V2.5C13.75 2.16848 13.6183 1.85054 13.3839 1.61612C13.1495 1.3817 12.8315 1.25 12.5 1.25H7.5C7.16848 1.25 6.85054 1.3817 6.61612 1.61612C6.3817 1.85054 6.25 2.16848 6.25 2.5V3.125H4.375C4.04348 3.125 3.72554 3.2567 3.49112 3.49112C3.2567 3.72554 3.125 4.04348 3.125 4.375V17.5C3.125 17.8315 3.2567 18.1495 3.49112 18.3839C3.72554 18.6183 4.04348 18.75 4.375 18.75H7.5V17.5ZM7.5 2.5H12.5V5H7.5V2.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25657_14689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalReview20);
export default __webpack_public_path__ + "static/media/ClinicalReview20.bd5a0d221bc225ea9a2007abfc6530bb.svg";
export { ForwardRef as ReactComponent };